
import { LandingTile } from "../types/landingPage";

export const landingPageTiles: LandingTile[] = [
  {
    title: "User Guide",
    titleSlug: "user_guide",
    permalink: "1a73c8",
    path: "user_guide",
    icon: "/images/site_icons/user-guide-icon.svg",
    desc: "A guide to Domino for data scientists.",
    enableVersions: true,
    excludedVersions: ["3.6","4.0","4.1","4.2","4.3","4.4","4.5","4.6","5.0","5.1","5.2","5.3","5.4","5.5","5.6","5.9","5.8", "5.7"],
    // Title slug needs to be updated if docs are changed.
    tileContent: [
      {
        type: "internal",
        title: "Governance",
        titleSlug: "governance",
        permalink: "7f8a63",
      },
      {
        type: "internal",
        title: "Generative AI",
        titleSlug: "build-and-evaluate-agentic-systems",
        permalink: "e437a3",
      },
      {
        type: "internal",
        title: "Projects",
        titleSlug: "work-with-projects",
        permalink: "a8e081",
      },
      {
        type: "internal",
        title: "Workspaces",
        titleSlug: "use-workspaces",
        permalink: "867b72",
      },
    ],
  },
  {
    title: "Admin Guide",
    titleSlug: "admin_guide",
    path: "admin_guide",
    icon: "/images/site_icons/admin-guide-icon.svg",
    desc: "Configure and manage Domino.",
    permalink: "b35e66",
    enableVersions: true,
    excludedVersions: ["3.6","4.0","4.1","4.2","4.3","4.4","4.5","4.6","5.0","5.1","5.2","5.3","5.4","5.5","5.6","5.9","5.8", "5.7"],
    // 2025-03: Added optional version field to specify specific version for link.
    // Default behaviour is to point to the current highest numeric version.
    // This allows the version to be specified.
    tileContent: [
      {
        type: "internal",
        title: "Domino architecture",
        titleSlug: "domino-architecture",
        permalink: "a0b173",
      },
      {
        type: "internal",
        title: "Configuration records",
        titleSlug: "configuration-records",
        permalink: "71d6ad",
      },
      {
        type: "internal",
        title: "Backup and restore",
        titleSlug: "backup-and-restore",
        permalink: "72ff13",
      },
      {
        type: "internal",
        title: "Kubernetes infrastructure",
        titleSlug: "kubernetes-infrastructure",
        permalink: "be5e54",
      },
    ],
  },
  {
    title: "API Guide",
    titleSlug: "api-guide",
    path: "api_guide",
    icon: "/images/site_icons/api-guide-icon.svg",
    desc: "A reference for data science developers.",
    permalink: "f35c19",
    enableVersions: true,
    excludedVersions: ["3.6","4.0","4.1","4.2","4.3","4.4","4.5","4.6","5.0","5.1","5.2","5.3","5.4","5.5","5.6","5.9","5.8", "5.7"],
    tileContent: [
      {
        type: "internal",
        title: "Domino Data API",
        titleSlug: "domino-data-api",
        permalink: "140b48",
      },
      {
        type: "internal",
        title: "Domino Platform API Reference",
        titleSlug: "domino-platform-api-reference",
        permalink: "8c929e",
      },
      {
        type: "internal",
        title: "The python-domino Library",
        titleSlug: "the-python-domino-library",
        permalink: "c5ef26",
      },
      {
        type: "internal",
        title: "Model Monitoring API",
        titleSlug: "model-monitoring-api",
        permalink: "c6b52a",
      },
    ],
  },
  {
    title: "Release Notes",
    titleSlug: "/release_notes/",
    path: "release_notes",
    icon: "/images/site_icons/release-notes-icon.svg",
    desc: "What's new in the latest Domino releases.",
    permalink: "41faed",
    enableVersions: false,
    excludedVersions: ["6.0"],
    tileContent: [
      {
        type: "external",
        title: "Domino Cloud",
        href: "https://docs.domino.ai/release-notes/cloud-release",
        badge: "New",
      },
      {
        type: "internal",
        title: "6.2.3",
        titleSlug: "/release_notes/6-2-3/",
        permalink: "062e83",
      },
      {
        type: "internal",
        title: "6.2.2",
        titleSlug: "/release_notes/6-2-2/",
        permalink: "7eeae8",
      },
      {
        type: "internal",
        title: "6.2.1",
        titleSlug: "/release_notes/6-2-1/",
        permalink: "97a933",
      },
      // This should always be present in this file, to mimic an "all versions" option without bespoke code for it
      {
        type: "internal",
        title: "Legacy Versions",
        titleSlug: "/release_notes/",
        permalink: "",
      },
    ],
  },
];
